import { TToken } from "./interfaces";
import { jwtDecode } from "jwt-decode";
import { IUserInfo } from "interfaces";

export default class Storage {
  private AUTH_TOKEN: string | undefined = "";

  public saveToken = (token: TToken | null): IUserInfo | null => {
    let userInfo: IUserInfo | null = null;

    if (token) {
      const decodedJwt: any = jwtDecode(token.access_token);

      userInfo = Object.keys(decodedJwt).reduce((acc, key) => {
        acc[key.toLowerCase()] = decodedJwt[key];
        return acc;
      }, {} as any);

      if (localStorage) {
        // do this async
        setTimeout(() => {
          localStorage.setItem("refresh_token", token.refresh_token);
        }, 100);
      }

      this.AUTH_TOKEN = token.access_token;
    } else {
      if (localStorage) {
        localStorage.removeItem("refresh_token");
        // localStorage.removeItem('user_roles');
      }
      this.AUTH_TOKEN = undefined;
    }

    return userInfo;
  };

  public dropToken = () => {
    if (localStorage) {
      localStorage.removeItem("refresh_token");
    }
    this.AUTH_TOKEN = undefined;
  };

  public getToken = () => {
    return this.AUTH_TOKEN;
  };

  public clearAuthToken = () => {
    this.AUTH_TOKEN = undefined;
  };

  public getRefreshToken = () => {
    return localStorage.getItem("refresh_token");
  };
}
